import MobileLayout from "@/components/one-to-one/MobileLayout.tsx";
import routes from "@/config/routes.ts";
import DashboardContentLayout from "@/layouts/DashboardContentLayout.tsx";
import useGlobals from "@/utils/hooks/useGlobals.ts";
import useOneToOne, { TutorInfo } from "@/utils/hooks/useOneToOne.ts";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@edusogno/primitives/avatar";
import Button from "@edusogno/primitives/button.js";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@edusogno/primitives/toggle-group";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";


type Tutor = TutorInfo;

export default function SelectTutor() {
  const navigate = useNavigate();
  const { setGlobalState } = useGlobals();

  const { setState, tutorList } = useOneToOne();
  const { t } = useTranslation();

  const [tutorToken, setTutorToken] = useState<string>("");

  useEffect(() => {
    setGlobalState("backgroundClass", "bg-brand-background");
  }, []);

  const handleTutorSelection = (token: string, tutor: Tutor | undefined) => {
    if (!tutor) return;
    setTutorToken(token);
    setState("tutor", tutor);
  };


  return (
    <DashboardContentLayout className={"until-lg:pb-0 until-lg:px-0"}>
      <MobileLayout
        heading={t("one_to_one.select_tutor.header")}
        subheading={t("one_to_one.select_tutor.subheader")}
      >
        <div className="flex flex-col justify-between flex-grow w-full h-auto bg-white">
          <div>
            <ToggleGroup
              type={"single"}
              className={"w-full  flex-1 flex-grow flex-col gap-4 "}
              value={tutorToken}
              onValueChange={(value) => handleTutorSelection(value, tutorList.find(tToken => tToken.token === value))}
            >
              {tutorList.map((r) => (
                <ToggleGroupItem
                  key={r?.token}
                  value={r?.token}
                  onClick={() => setState("tutorSelected", r)}
                  className={
                    "flex h-[60px]   flex-row lg:gap-5 px-6 py-2 text-brand hover:bg-[--grey200] hover:text-brand data-[state=on]:[--color:white] [--color:--primary] data-[state=on]:bg-primary  data-[state=on]:text-white justify-between rounded-md items-center center w-full bg-[--grey200]"
                  }
                >
                  <div
                    className={
                      "flex-row justify-start flex items-center gap-2 w-full"
                    }
                  >
                    <Avatar className={"w-[49px] h-[49px]"}>
                      <AvatarImage src={r?.image} />
                      <AvatarFallback>
                        {r.name.slice(0, 2).toUpperCase()}
                      </AvatarFallback>
                    </Avatar>
                    <p className={" text-sm font-bold"}>{r.name}</p>
                  </div>
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </div>
          <div
            className={
              "flex flex-row mt-auto items-end justify-center w-full gap-x-2 "
            }
          >
            <Button size={"md"} color={"white"} onClick={() => navigate(-1)}>
              {t("btns.back")}
            </Button>
            <Button
              size={"md"}
              disabled={!tutorToken}
              onClick={() =>
                navigate(routes.one_to_one_second_session, {
                  replace: true,
                })
              }
            >
              {t("btns.next")}
            </Button>
          </div>
        </div>
      </MobileLayout>
    </DashboardContentLayout>
  );
}
